export function makeSendData(senddata) {
    const m_bodylen = NCbyteLength(senddata)
    const m_totlen = 12 + m_bodylen

    return NCpad(m_totlen, 4) + "VCAT    " + NCpad(m_bodylen, 4) + senddata
}

function NCbyteLength(str) {
    let length = 0

    for (let idx = 0; idx < str.length; idx++) {
        const c = encodeURI(str.charAt(idx))

        if (c.length === 1) length++
        else if (c.indexOf("%u") !== -1) length += 3
        else if (c.indexOf("%") !== -1) length += c.length / 3
    }

    return length
}

function NCpad(n, width) {
    return n.toString().padStart(width, "0")
}
